export const Country = [
    { value: '', label: '--Choose--' },
    { value: 'Choice 1', label: 'USA' },
    { value: 'Choice 2', label: 'Italy' },
    { value: 'Choice 3', label: 'Australia' },
    { value: 'Choice 4', label: 'England' },
    { value: 'Choice 5', label: 'Spain' }
]
export const State = [
    { value: 'Choice 1', label: 'California' },
    { value: 'Choice 2', label: 'Alaska' },
    { value: 'Choice 3', label: 'Colorado' },
    { value: 'Choice 4', label: 'Arizona' },
    { value: 'Choice 5', label: 'Delaware' }
]
